(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('SearchController', SearchController);

  /* ngInject */
  function SearchController($stateParams, searchService, sessionService) {
    let vm = this;

    vm.currentPage = $stateParams.currentPage || 1;
    vm.deselectAllFilters = deselectAllFilters;
    vm.filterByType = filterByType;
    vm.filterTypes = {
      article : true,
      event: true,
      helpful_resource: true,
      manual: true,
      policy_template: true,
      quick_guide: true,
      topic: true,
      webinar: true,
      check_list: true
    };
    vm.getResults = getResults;
    vm.loading = false;
    vm.pageChange = pageChange;
    vm.query = $stateParams.query;
    vm.results = [];
    vm.selectAllFilters = selectAllFilters;
    vm.totalCount = null;

    getResults();

    function deselectAllFilters() {
      for (let type in vm.filterTypes) {
        vm.filterTypes[type] = false;
      }

      vm.getResults();
    }

    function filterByType(result) {
      return vm.filterTypes[result.type];
    }

    function getResults() {
      vm.loading = true;

      let params = { query: vm.query, page: vm.currentPage };
      Object.assign(params, vm.filterTypes);

      searchService(sessionService.getAuthToken()).query(params, response => {
        vm.totalCount = response.meta.total_count;
        vm.results = response.search_results.map(result => {
          let model = result._source;

          switch(result._index) {
          case 'articles':
            return {
              id: `article-${model.id}`,
              type: 'article',
              displayType: 'Article',
              url: `/compliance_services/articles/${model.id}`,
              icon: 'glyphicons-newspaper',
              title: model.title,
              description: model.body,
              updated_at: model.updated_at
            };
          case 'events':
            return {
              id: `event-${model.id}`,
              type: 'event',
              displayType: 'Event',
              url: `/compliance_services/events/${model.id}`,
              icon: 'glyphicons-calendar',
              title: model.title,
              description: model.body,
              updated_at: model.updated_at
            };
          case 'quick_guides':
            return {
              id: `quick-guide-{$model.id}`,
              type: 'quick_guide',
              displayType: 'Quick Guide',
              url: `/compliance_services/quick_guides/${model.id}`,
              icon: 'glyphicons-list-alt',
              title: model.title,
              description: model.description,
              updated_at: model.updated_at
            };
          case 'helpful_resources':
            return {
              id: `helpful-resource-{$model.id}`,
              type: 'helpful_resource',
              displayType: 'Helpful Resource',
              url: `/compliance_services/helpful_resources/${model.id}`,
              icon: 'glyphicons-info-sign',
              title: model.title,
              description: model.description,
              updated_at: model.updated_at
            };
          case 'manuals':
            return {
              id: `manual-${model.id}`,
              type: 'manual',
              displayType: 'Manual',
              url: `/compliance_services/manuals/${model.id}`,
              icon: 'glyphicons-log-book',
              title: model.title,
              description: model.description,
              updated_at: model.updated_at
            };
          case 'policy_templates':
            return {
              id: `policy-template-${model.id}`,
              type: 'policy_template',
              displayType: 'Policy Template',
              url: `/compliance_services/policy_templates/${model.id}`,
              icon: 'glyphicons-article',
              title: model.title,
              description: model.description,
              updated_at: model.updated_at
            };
          case 'topics':
            return {
              id: `topic-${model.id}`,
              type: 'topic',
              displayType: 'Topic',
              url: `/compliance_services/topics/${model.id}`,
              icon: 'glyphicons-education',
              title: model.name,
              description: model.body,
              updated_at: model.updated_at
            };
          case 'webinars':
            return {
              id: `webinar-${model.id}`,
              type: 'webinar',
              displayType: 'Webinar',
              url: `/compliance_services/webinars/${model.id}`,
              icon: 'glyphicons-keynote',
              title: model.title,
              description: model.description,
              updated_at: model.updated_at
            };
          case 'check_lists':
            return {
              id: `check-list-{$model.id}`,
              type: 'check_list',
              displayType: 'Check List',
              url: `/compliance_services/check_lists/${model.id}`,
              icon: 'glyphicons-list-alt',
              title: model.title,
              description: model.description,
              updated_at: model.updated_at
            };
          default:
          }
        });

        vm.loading = false;
      });
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.currentPage = newPageNumber;
      getResults();
    }

    function selectAllFilters() {
      for (let type in vm.filterTypes) {
        vm.filterTypes[type] = true;
      }

      vm.getResults();
    }
  }
})();
